// Single source of truth for site-wide destinations.
// Update these values in one place — every component reads from here.

export const CONTACT_EMAIL = "info@revgenworkforce.com";
export const CALENDLY_URL = "https://cal.com/rggsales/30min";
